import { TitleSource } from 'Data/ReduxViewModels/App/types';
import { hasNonEmptyValue } from 'Lib/Any';
import { combine } from 'Lib/Hooks/Selectors';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

/**
 * A hook that, when used, will apply the app title
 * to the web page whenever it changes (based on the app state)
 */
export function useAppTitleApplicator() {
  const pageTitle = useSelector(
    combine(
      [(state) => state.app.pageTitle[TitleSource.Generic], (state) => state.app.pageTitle[TitleSource.Specific]],
      (genericTitle, specificTitle) => specificTitle ?? genericTitle
    )
  );

  useEffect(() => {
    document.title = [pageTitle, 'QEST Web App'].filter(hasNonEmptyValue).join(' - ');
  }, [pageTitle]);
}
